import React from "react";
import "./Essence_Of_Meditation.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";

const Essence_Of_Meditation = ({ essences }) => {
  const data = [
    "Silence the mind and connect to the present moment.",
    "Observe your breath, thoughts, or a mantra.",
    "Let go of distractions and mental clutter.",
    "Cultivate inner stillness, awareness, and peace.",
  ];

  return (
    <section className="Essence_Of_Meditation">
      <div className="container">
        <Common_Title_2 subText="Essence of Meditation" />

        <div className="content_holder">
          <div className="row">
            {essences?.map((item) => {
              return (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                  <div className="yellow_card">
                    <p className="inner_text">{item?.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Essence_Of_Meditation;
